import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const MicrophonePermissionModal = ({ isOpen, permissionState, onEnableClick, onLogout }) => {
  const isDenied = permissionState === 'denied';

  return (
    <Modal isOpen={isOpen} size="md" centered backdrop="static" keyboard={false}>
      <ModalBody>
        <div className="d-flex flex-column align-items-center pt-4 text-center">
          <Icon.MicOff size={60} className="text-danger" />

          <div className="fs-4 pt-3 fw-semibold">Microphone Access Required</div>

          {!isDenied ? (
            <div className="fs-6 pt-3 text-muted">
              This system handles real-time voice calls. Please enable microphone access to
              continue.
            </div>
          ) : (
            <>
              <div className="fs-6 pt-3 text-muted">Microphone access is blocked.</div>

              <div className="fs-6 pt-3 text-danger">
                Click 🔒 in address bar → Microphone → Allow → Refresh page
              </div>
            </>
          )}
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-center">
        {!isDenied && (
          <Button
            onClick={onEnableClick}
            className="bg-primary border-primary"
            style={{ width: '180px' }}
          >
            Enable Microphone
          </Button>
        )}
        <Button
          onClick={onLogout}
          className="btn-danger border-danger ms-2"
          style={{ width: '180px' }}
        >
          Logout
        </Button>
      </ModalFooter>
    </Modal>
  );
};

MicrophonePermissionModal.propTypes = {
  isOpen: PropTypes.bool,
  permissionState: PropTypes.string,
  onEnableClick: PropTypes.func,
  onLogout: PropTypes.func
};

export default MicrophonePermissionModal;
